var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAffiliate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4164 0.327676C12.146 -0.336713 13.3 0.0625672 13.4938 1.04541L15.4739 11.1139C15.6669 12.0976 14.7553 12.9276 13.8319 12.6084L7.81382 10.5287C7.5714 10.4447 7.38704 10.2386 7.32506 9.98234L6.26438 5.56763C6.1977 5.28878 6.28635 4.99457 6.49581 4.80382L11.4164 0.327676ZM4.17676 5.94427L1.68039 6.58038C0.847228 6.79295 0.33964 7.66021 0.545971 8.51858L0.980599 10.3283C1.15476 11.0517 1.78082 11.5374 2.4712 11.5447C2.67988 11.5471 2.86346 11.6862 2.91288 11.8947L3.71389 15.2288C3.8449 15.7727 4.37917 16.1049 4.90715 15.9699L6.42129 15.5836C6.94927 15.4486 7.27171 14.8982 7.1407 14.3542L6.04628 9.79725C6.04236 9.76896 6.03687 9.74148 6.03059 9.714L5.29157 6.63615C5.16918 6.12775 4.67023 5.81819 4.17754 5.94347L4.17676 5.94427Z",
    fill: "#00AABE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAffiliate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_affiliate.a8ba80f25af72b04eb9af18f9e3c6b0f.svg";